import { Steps } from 'antd';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';

import { FormButton } from 'common/components';

import useWizard from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/context/useWizard';
import { MODAL_TYPES } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/config/stepModalConstants';

import { sendDownload } from 'config/axios';
import { DOWNLOAD_TEMPLATE_WIZARD } from 'services/product/endpoints';

import 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/styles/SubmissionMethod.less';

const TemplateSubmissionSteps = () => {
  const { actions } = useWizard();

  return (
    <Steps direction='vertical' size='small' className='wizard-template-steps'>
      <Steps.Step
        status='process'
        title='Download the product template'
        description={
          <FormButton
            text='Download Template'
            type='default'
            icon={<DownloadOutlined />}
            onClick={() => sendDownload({ url: DOWNLOAD_TEMPLATE_WIZARD })}
          />
        }
      />
      <Steps.Step status='process' title='Fill out the template' />
      <Steps.Step
        status='process'
        title='Load the completed template'
        description={
          <FormButton
            text='Upload Template'
            icon={<UploadOutlined />}
            onClick={() => actions.openModal(MODAL_TYPES.LOAD_TEMPLATE_UPLOAD)}
          />
        }
      />
    </Steps>
  );
};

export default TemplateSubmissionSteps;
